import styled from "styled-components";

const StyledLetters = styled.nav`
    display: flex;
    flex-direction: row;
`;

const StyledLetter = styled.a`
    color: #000;
    cursor: pointer;
    display: block;
    flex: none;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    width: 20px;

    &:hover {
        background: #000;
        color: #fff;
    }

    &:not([href]) {
        background: none !important;
        color: #ddd !important;
        cursor: default;
    }
`;

export default function Letters(props) {
    const { active, all, selector } = props;

    const allLetters = all.map(selector).filter((e, i, a) => a.indexOf(e) === i).sort();
    const activeLetters = active.map(selector);

    return (
        <StyledLetters>
            {
                allLetters.map(
                    (letter) => (
                        <StyledLetter
                            href={ activeLetters.includes(letter) ? `#${ letter }` : undefined }
                            key={ letter }
                        >
                            { letter }
                        </StyledLetter>
                    )
                )
            }
        </StyledLetters>
    );
}
